import * as React from "react";
import { withRouter } from "react-router-dom";
import logoBG from "../../assets/images/logos/overgas-direct-logo.png";
import logoEN from "../../assets/images/logos/overgas-direct-logo-en.png";
import demoEN from "../../assets/images/logos/gasified-logo.png";
//import UserMenuComponent from '../../components/profile/userMenu';
import Language from '../../components/language/language';
import { Link } from "react-router-dom";
import Translate from '../../common/functions/translate';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import AuthService from '../../services/authService';
import { faSyncAlt, faBars, faUser } from '@fortawesome/free-solid-svg-icons';
import Drawer from '@material-ui/core/Drawer';
import MenuNavigation from '../navigation/menuNavigation';
import Avatar from '@material-ui/core/Avatar';
import * as Constants from "../../common/constants";

interface IProps {
  lang: string;
  history: any;
}

interface IState {
  showSynchroBtn: boolean;
  isDrawerOpen: boolean;
}

class HeaderComponent extends React.Component<IProps, IState> {
  authService = new AuthService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      showSynchroBtn: true,
      isDrawerOpen: false
    };
  }
  componentDidMount() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);

    if (!navigator.onLine) {
      this.setState({
        showSynchroBtn: false
      });
    }
  }

  updateOnlineStatus = () => {
    if (navigator.onLine) {
      this.setState({
        showSynchroBtn: true
      });
    }

    if (!navigator.onLine) {
      this.setState({
        showSynchroBtn: false
      });
    }
  }

  changeRoute = (route) => {
    this.setState({ isDrawerOpen: false }, () => this.props.history.push(route));
  }

  synchronize = () => {
    this.props.history.push('/synchronization?backUrl=' + this.props.history.location.pathname);
  }

  public render() {
    return (
      <>
        <header className="app-header">
          <div className="app-logo-wrap">

            <Link to="/">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginRight: "10px" }}>
                {
                  Constants.envName === 'Demo-EN' ?
                    <img src={demoEN} className="app-logo" alt="logo" /> :
                    <img src={this.props.lang === "bg" ? logoBG : logoEN} className="app-logo" alt="logo" />
                }
                <div className="app-title">{Translate("Mobile")}</div>
              </div>
            </Link>

            {this.authService.checkIsTrader() || this.authService.checkIsRegionalManager() ?
              <div className="app-header-buttons">
                <Link to="/newoffer">
                  <div className="header-button new-offer">
                    <div className="header-button-text">
                      <div>{Translate("Creating")}</div>
                      <div className="detail">{Translate("new offer")}</div>
                    </div>
                    <div><FontAwesomeIcon icon={faPlus} /></div>
                  </div>
                </Link>
                <Link to="/offers">
                  <div className="header-button existing-offer">
                    <div className="header-button-text">
                      <div>{Translate("Opening")}</div>
                      <div className="detail">{Translate("existing offer")}</div>
                    </div>
                    <div><FontAwesomeIcon icon={faFolderOpen} /></div>
                  </div>
                </Link>
                {this.state.showSynchroBtn
                  ? <div style={{ cursor: 'pointer' }} onClick={this.synchronize}>
                    <div className="header-button synchronization">
                      <div className="header-button-text">
                        <div>{Translate("Synchronization")}</div>
                        <div className="detail">{Translate("local data with database")}</div>
                      </div>
                      <div><FontAwesomeIcon icon={faSyncAlt} /></div>
                    </div>
                  </div>
                  : null
                }
              </div> : null}
            <span>{Constants.envName !== "Production" ? Constants.envName : null}</span>
          </div>
          {this.authService.isAuthenticated() ?
            <>
              <div className="app-header-sidebar">
                <div style={{ textTransform: "none", color: "#555", display: "flex", alignItems: "center", marginRight: "10px" }}>
                  <Avatar style={{ width: "24px", height: "24px", fontSize: "1em", marginRight: "7px" }}>
                    <FontAwesomeIcon icon={faUser} />
                  </Avatar>
                  <div className="header-user-name" style={{ marginRight: "7px", fontSize: 14 }}>
                    {this.authService.getUserName()}
                    <div style={{ fontSize: 12, marginTop: "3px", color: "#777" }}>
                      {Translate(this.authService.getUserRole()) + " - " + this.authService.getRegion()}
                    </div>
                  </div>
                </div>
                <div className="app-header-sandwitch" style={{ display: 'inline' }} onClick={() => this.setState({ isDrawerOpen: true })}>
                  <FontAwesomeIcon icon={faBars} size="lg" />
                </div>
              </div>
            </> :
            <div className="app-header-language">
              <Language></Language>
            </div>}
        </header>
        <Drawer
          anchor="right"
          open={this.state.isDrawerOpen}
          onClose={() => this.setState({ isDrawerOpen: false })}>
          <div
            tabIndex={0}
            role="button">
            <MenuNavigation
              changeRoute={this.changeRoute}
              showSynchroBtn={this.state.showSynchroBtn}
              synchronize={this.synchronize}
              closeDrawer={() => this.setState({ isDrawerOpen: false })} />
          </div>
        </Drawer>
      </>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default withRouter(connect(mapsStateToProps, null)(HeaderComponent));